import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import { ImageSlider } from "./ImageSlider";
import ReactModal from "react-modal";
import { Button, PaddingContainer } from "../../styles/Global.styled";


const StyledModal = styled(Modal)`

  overlay: {
    position: fixed; 
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 1);
    z-index: 10;
}
  content: {
    
    }
`;

const SliderContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1200px;
  max-height: 700px;

  position: relative;
  background: white;
  padding: 20px;
  border-radius: 10px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
border-radius: 5px;
  &:hover {
    background: darkred;
  }
`;

const ModalSlider = ({ images }) => {
  const [modalOpen, setModalOpen] = useState(false);
   useEffect(() => {
  if (modalOpen) {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden"; // Bloquea scroll en html
  } else {
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
  }
}, [modalOpen]);



  return (
    <>
        
             <Button onClick={() => setModalOpen(true)}>Ver Detalles</Button>
        
      <ReactModal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} 
            style={{
              overlay: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    bottom:0,
                    right:0,
                    width: "100%",
                    height: "100%",
                    zIndex: 99999,
                    background: "rgba(5, 0, 77, 0.8)",

              },
              content: {
                position: "fixed",
                top: 0,
                left: 0,
                bottom:0,
                right:0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "rgba(0, 0, 0, 0.7)",
                zIndex: 20,
                border: "none",
              }
            }}>
        <SliderContainer>
          <CloseButton onClick={() => setModalOpen(false)}>X</CloseButton>
          <ImageSlider images={images} />
        </SliderContainer>
      </ReactModal>
    </>
  );
};

export default ModalSlider;